'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$127(ps$80) {
  this.a6M = null;
  this.a6M = ps$80;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$127 as $c_Lmealorama_jsonCodecs$package$$anon$127 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$127.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$127;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$127() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$127 as $h_Lmealorama_jsonCodecs$package$$anon$127 };
$h_Lmealorama_jsonCodecs$package$$anon$127.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6M.a.length;
});
$p.g = (function(i) {
  return this.a6M.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$127 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$127, "mealorama.jsonCodecs$package$$anon$127", ({
  IC: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$127 as $d_Lmealorama_jsonCodecs$package$$anon$127 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$127.js.map
